import { IPRAttributes } from '@upright/common/model/input/companies/products/ipr';
import { ProductFileEvidence } from './types';

/**
 * PLT-7015: whether a row's attributes were set by the chat from uploaded files, and so must be
 * kept when the row is matched. Needs the attributes as well as the marker: a row with no `ipr`
 * (the chat saved it while the attribute rules could not be loaded) is matched like a row added by
 * hand.
 */
export function hasAttributesFromFiles(row: { fileEvidence?: ProductFileEvidence; ipr?: IPRAttributes }): boolean {
  return row.fileEvidence?.attributesFromFiles === true && row.ipr !== undefined;
}
